import { render, staticRenderFns } from "./LoaderDotsV2.vue?vue&type=template&id=18ae67c3"
import script from "./LoaderDotsV2.vue?vue&type=script&lang=js"
export * from "./LoaderDotsV2.vue?vue&type=script&lang=js"
import style0 from "./LoaderDotsV2.vue?vue&type=style&index=0&id=18ae67c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports